// 頁首導覽列要知道兩件事：
// - 現在有沒有進行中的活動（目前頁首沒有用到，「活動辦法」改為一律露出）
// - 中獎名單公佈了沒：公佈時間到了（且名單已產出）才露出「中獎名單」，
//   之前點進去只會看到「尚未公布」
//
// 每一頁的頁首都要問一次，所以用固定 key 的 useAsyncData 共用同一份結果，一次請求就夠；
// 介面本身只回一個布林值，不必為了問這件事把整頁的富文本撈出來。
export async function useActivityStatus() {
  const api = useApi()

  const { data } = await useAsyncData('activity-status', () =>
    api.get('/front/activity/status').catch(() => null)
  )

  // 介面掛掉時一律當作有活動：選單少一項使用者不會知道自己少看了什麼，
  // 寧可留著入口（那一頁本來就退得回上一檔的內容），也不要因為一次請求失敗就把它藏掉
  // 中獎名單反過來，介面掛掉時不露出：還沒公佈就先擺出入口，等於提早預告一張空頁
  return {
    ongoing: computed(() => data.value?.ongoing !== false),
    winnersAnnounced: computed(() => data.value?.winnersAnnounced === true)
  }
}
